module.exports = __webpack_public_path__ + "img/bg-scene-4.0ce4f840.png";